<template>
    <v-container class="height-100">
        <v-row v-if="filtered_albums">
        <v-col 
            xl="2" lg="3" md="4" sm="6" cols="12" 
            v-for="album in filtered_albums"
            :key="album.id" 
        >
            <Items 
            :src="album.images.reduceRight((accumulator, current) => accumulator.height < current.height ? current : accumulator)['url']"
            :uri="album.uri"
            :name="album.name"
            :artists="album.artists"
            :type="album.album_type"
            :release_date="formatDate(album.release_date)"
            >
            </Items>
        </v-col>
        </v-row>
        <v-row align="center" v-else class="height-100">
        <v-spacer/>
        <v-col class="text-center" cols="12">
            <v-row>
            <v-col cols="12">
                <v-progress-circular
                :size="70"
                :width="7"
                color="primary"
                indeterminate
            ></v-progress-circular>
            </v-col>
            <v-col cols="12">
            {{ albums.length }} albums loaded
            </v-col>
        </v-row>
        </v-col>
        <v-spacer/>
        </v-row>
    </v-container>
</template>
  
<script>
import { mapActions, mapState, mapMutations } from 'vuex'
// eslint-disable-next-line no-unused-vars
import helper from '../helper'
import Items from './../components/Items'

export default {
name: 'Spotify',
components: {
    Items
},
data() {
    return {
        filtered_albums: null,
    }
},
watch: {
    date() {
    this.filtered_albums = this.getTimedAlbums();
    }
},
async created() {
    if(this.token.length === 0) this.$router.push('/');
        await this.GetFollowedArtist();

    if(this.albums.length !== 0) this.CLEAR_ALBUMS();
    
    for(const artist of this.artists)
        await this.GetAlbumFromArtist(artist.id);
    this.filtered_albums = this.getTimedAlbums();
},
methods: {
    ...helper,
    ...mapMutations('SpotifyModule', ['CLEAR_ALBUMS']),
    ...mapActions('SpotifyModule', ['GetFollowedArtist', 'GetAlbumFromArtist']),
    getTimedAlbums() {
        let x = this.albums.filter(album => new Date(this.date.split('T')[0]) <= new Date(album.release_date))
        x = [...new Map(x.map(v => [v.id, v])).values()]
        x.sort((a, b) => a.release_date < b.release_date ? 0 : -1);
        return x;
    }
},
computed: {
    ...mapState('SpotifyModule', {
        token: state => state.token,
        artists: state => state.artists,
        albums: state => state.albums,
        date: state => state.date
    })
}
}
</script>